<template>
    <a :href="participant.url" class="orchestra-item">
        <div class="orchestra-item__media" v-if="participant.image">
            <div class="orchestra-item__intrinsic-ratio">
                <img
                    class="orchestra-item__image"
                    :src="imageUrl(participant, {width: 250, height: 250})"
                    width="150"
                    height="150"
                    :alt="participant.image.alt"
                />
            </div>
        </div>

        <div class="orchestra-item__details" :class="{'orchestra-item__details--full': participant.image}">
                <h3 class="orchestra-item__name">{{ participant.lastName }}, {{ participant.firstName }}</h3>
                <!-- 3 cl<hass="orchestra-item__name">{{ participant.firstName }} {{ participant.lastName }}</h3> -->

            <p class="orchestra-item__role" v-if="participant.role">{{ participant.role }}</p>
            <p class="orchestra-item__position" v-if="participant.position">{{ participant.position }}</p>
        </div>
    </a>
</template>

<script>
import {inject} from 'vue';

export default {
  name: 'OrchestraItem',
  props: {
    participant: {
      type: Object,
      required: true,
    }
  },
  setup(props) {
    const imageUrl = inject('imageUrl');

    return {
        imageUrl,
    }
  }
}
</script>
